import { SUBSCRIPTION_STATUS, TRANSACTION_STATUS, USER_STATUS } from '../constants/status';

export const fallbackVerificationCandidates = [
  {
    id: 101,
    uuid: 'user-uuid-101',
    name: 'John Doe',
    email: 'john.doe@slpconnect.com',
    status: USER_STATUS.REVIEWING,
    submittedAt: '2024-09-18T16:45:00.000Z',
    documents: ['Government ID', 'SLP License'],
  },
  {
    id: 102,
    uuid: 'user-uuid-102',
    name: 'Ava Patel',
    email: 'ava.patel@therapyhub.io',
    status: USER_STATUS.REVIEWING,
    submittedAt: '2024-09-19T13:20:00.000Z',
    documents: ['SLP License', 'Certification Letters'],
  },
  {
    id: 103,
    uuid: 'user-uuid-103',
    name: 'Miguel Santos',
    email: 'miguel.santos@speechpro.org',
    status: USER_STATUS.REVIEWING,
    submittedAt: '2024-09-20T09:15:00.000Z',
    documents: ['Government ID', 'Insurance Proof'],
  },
];

export const fallbackUsersWithDetails = [
  {
    id: 201,
    uuid: 'user-uuid-201',
    name: 'Emily Carter',
    email: 'emily.carter@clarityspeak.com',
    userType: 'slp',
    status: USER_STATUS.UNPAID,
    joined: '2024-08-27T08:52:00.000Z',
    subscription: {
      plan: 'Premium Plan',
      start: '2024-08-27T08:52:00.000Z',
      end: '2024-09-27T08:52:00.000Z',
      status: SUBSCRIPTION_STATUS.ACTIVE,
      autoRenew: true,
    },
    transactions: [
      {
        id: 501,
        ref: 'TXN-823945',
        amount: 99.99,
        status: TRANSACTION_STATUS.COMPLETED,
        createdAt: '2024-08-27T08:55:00.000Z',
      },
    ],
  },
  {
    id: 202,
    uuid: 'user-uuid-202',
    name: 'Liam Nguyen',
    email: 'liam.nguyen@soundstep.io',
    userType: 'slp',
    status: USER_STATUS.ACTIVE,
    joined: '2024-05-15T14:10:00.000Z',
    subscription: {
      plan: 'Enterprise Plan',
      start: '2024-08-01T09:00:00.000Z',
      end: '2024-11-01T09:00:00.000Z',
      status: SUBSCRIPTION_STATUS.ACTIVE,
      autoRenew: false,
    },
    transactions: [
      {
        id: 502,
        ref: 'TXN-129384',
        amount: 249.0,
        status: TRANSACTION_STATUS.COMPLETED,
        createdAt: '2024-08-01T09:05:00.000Z',
      },
    ],
  },
  {
    id: 203,
    uuid: 'user-uuid-203',
    name: 'Sophia Brown',
    email: 'sophia.brown@voicecare.co',
    userType: 'slp',
    status: USER_STATUS.UNVERIFIED,
    joined: '2024-09-12T11:40:00.000Z',
    subscription: {
      plan: 'Basic Plan',
      start: null,
      end: null,
      status: SUBSCRIPTION_STATUS.INACTIVE,
      autoRenew: false,
    },
    transactions: [
      {
        id: 503,
        ref: 'TXN-998712',
        amount: 29.99,
        status: TRANSACTION_STATUS.REFUNDED,
        createdAt: '2024-09-13T15:22:00.000Z',
      },
    ],
  },
];

export const fallbackPlans = [
  {
    uuid: 'plan-uuid-basic',
    name: 'Basic Plan',
    details: 'Perfect for new SLPs getting started with digital therapy.',
    price: 29.99,
    limit: 10,
    stripeId: 'price_basic_001',
    squareId: 'sq_basic_001',
  },
  {
    uuid: 'plan-uuid-premium',
    name: 'Premium Plan',
    details: 'Advanced analytics and session templates for growing practices.',
    price: 99.99,
    limit: 100,
    stripeId: 'price_premium_001',
    squareId: 'sq_premium_001',
  },
  {
    uuid: 'plan-uuid-enterprise',
    name: 'Enterprise Plan',
    details: 'Unlimited patients, multi-seat access, and dedicated success manager.',
    price: 249.0,
    limit: 999,
    stripeId: 'price_enterprise_001',
    squareId: 'sq_enterprise_001',
  },
];

export const fallbackPolicies = [
  {
    id: 1,
    title: 'Terms of Service',
    effectiveDate: '2024-07-01T00:00:00.000Z',
    summary:
      'Defines acceptable use, account responsibilities, and compliance requirements for SLPs.',
  },
  {
    id: 2,
    title: 'Privacy Policy',
    effectiveDate: '2024-06-15T00:00:00.000Z',
    summary:
      'Outlines data processing practices, HIPAA alignment, and client confidentiality safeguards.',
  },
  {
    id: 3,
    title: 'Refund Policy',
    effectiveDate: '2024-05-01T00:00:00.000Z',
    summary:
      'Explains eligibility criteria, timelines, and escalation paths for subscription refunds.',
  },
];

export const fallbackSubscriptions = [
  {
    id: 601,
    user: 'Emily Carter',
    plan: 'Premium Plan',
    start: '2024-08-27T08:52:00.000Z',
    end: '2024-09-27T08:52:00.000Z',
    status: SUBSCRIPTION_STATUS.ACTIVE,
    autoRenew: true,
  },
  {
    id: 602,
    user: 'Liam Nguyen',
    plan: 'Enterprise Plan',
    start: '2024-08-01T09:00:00.000Z',
    end: '2024-11-01T09:00:00.000Z',
    status: SUBSCRIPTION_STATUS.ACTIVE,
    autoRenew: false,
  },
  {
    id: 603,
    user: 'Sophia Brown',
    plan: 'Basic Plan',
    start: '2024-09-01T08:00:00.000Z',
    end: '2024-10-01T08:00:00.000Z',
    status: SUBSCRIPTION_STATUS.INACTIVE,
    autoRenew: false,
  },
];

export const fallbackTransactions = [
  {
    id: 701,
    ref: 'TXN-823945',
    user: 'Emily Carter',
    amount: 99.99,
    status: TRANSACTION_STATUS.COMPLETED,
    type: 'subscription',
    createdAt: '2024-08-27T08:55:00.000Z',
  },
  {
    id: 702,
    ref: 'TXN-129384',
    user: 'Liam Nguyen',
    amount: 249.0,
    status: TRANSACTION_STATUS.COMPLETED,
    type: 'subscription',
    createdAt: '2024-08-01T09:05:00.000Z',
  },
  {
    id: 703,
    ref: 'TXN-998712',
    user: 'Sophia Brown',
    amount: 29.99,
    status: TRANSACTION_STATUS.REFUNDED,
    type: 'subscription',
    createdAt: '2024-09-13T15:22:00.000Z',
  },
  {
    id: 704,
    ref: 'TXN-552318',
    user: 'Ava Patel',
    amount: 59.99,
    status: TRANSACTION_STATUS.PENDING,
    type: 'add-on',
    createdAt: '2024-09-18T10:42:00.000Z',
  },
];

export const fallbackRecentActivity = [
  {
    id: 801,
    label: 'Emily Carter renewed Premium Plan',
    timestamp: '2024-09-20T12:45:00.000Z',
  },
  {
    id: 802,
    label: '3 new verification requests awaiting review',
    timestamp: '2024-09-19T18:05:00.000Z',
  },
  {
    id: 803,
    label: 'Refund issued to Sophia Brown',
    timestamp: '2024-09-18T09:22:00.000Z',
  },
  {
    id: 804,
    label: 'Policy update published: Privacy Policy',
    timestamp: '2024-09-16T14:10:00.000Z',
  },
];

export const placeholderStats = [
  { title: 'Total Users', value: 0, change: '—', accent: 'primary', progress: 0 },
  { title: 'Total Organizations', value: 0, change: '—', accent: 'primary', progress: 0 },
  { title: 'Active Subscriptions', value: 0, change: '—', accent: 'success', progress: 0 },
  { title: 'Trialing Subscriptions', value: 0, change: '—', accent: 'info', progress: 0 },
  { title: 'Pending Subscriptions', value: 0, change: '—', accent: 'warning', progress: 0 },
  { title: 'Freemium Users', value: 0, change: '—', accent: 'info', progress: 0 },
  { title: 'Monthly Revenue', value: '$0', change: '—', accent: 'primary', progress: 0 },
];
